import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Route, NavLink, Switch } from "react-router-dom";
import { faChartLine, faChartBar } from "@fortawesome/free-solid-svg-icons";
import ChartsPage from "./EmployerPerformance/ChartsPage";
import AgencyPerformance from "./AgencyPerformance/AgencyPerformance";
import {
  TabsWrapper,
  RouterNav,
  RouterList,
  RouterItem,
  TabIcon,
  TabText,
} from "./styles/tabs-styles";

export interface ITabsProps {
  hubAdminPresent: boolean;
  isPortalUser: boolean;
  isPremiumOrPortalUser: boolean;
}

export const Tabs: FunctionComponent<ITabsProps> = ({
  hubAdminPresent,
  isPortalUser,
  isPremiumOrPortalUser,
}) => (
  <TabsWrapper>
    <RouterNav id="tab-nav">
      <RouterList>
        <RouterItem>
          <NavLink to="/your-performance" id="your-performance-link">
            <TabIcon>
              <FontAwesomeIcon icon={faChartLine} />
            </TabIcon>
            <TabText>Your Performance</TabText>
          </NavLink>
        </RouterItem>
        <RouterItem>
          <NavLink to="/agency-performance">
            <TabIcon>
              <FontAwesomeIcon icon={faChartBar} />
            </TabIcon>
            <TabText data-test-id="agency-performance-link">
              Agency Performance
            </TabText>
          </NavLink>
        </RouterItem>
      </RouterList>
    </RouterNav>
    <Switch>
      <Route
        exact
        path="/"
        render={() => (
          <ChartsPage
            hubAdminPresent={hubAdminPresent}
            isPortalUser={isPortalUser}
          />
        )}
      />
      <Route
        exact
        path="/your-performance"
        render={() => (
          <ChartsPage
            hubAdminPresent={hubAdminPresent}
            isPortalUser={isPortalUser}
          />
        )}
      />
      <Route
        exact
        path="/agency-performance"
        render={() => (
          <AgencyPerformance
            hubAdminPresent={hubAdminPresent}
            isPremiumOrPortalUser={isPremiumOrPortalUser}
          />
        )}
      />
    </Switch>
  </TabsWrapper>
);

Tabs.propTypes = {
  hubAdminPresent: PropTypes.bool.isRequired,
  isPortalUser: PropTypes.bool.isRequired,
  isPremiumOrPortalUser: PropTypes.bool.isRequired,
};

export default Tabs;
